import {Injectable} from '@angular/core';
import {BaseProvider} from '../base.provider';
import {SpecialistsService} from './specialists.service';
import {BehaviorSubject} from 'rxjs';
import {SpecialistViewInterface} from '@interfaces/specialist.interface';
import {AuthService} from '@services/auth.service';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';

@Injectable()
export class SpecialistsProvider extends BaseProvider<SpecialistViewInterface[]> {

    constructor(
        service: SpecialistsService,
        private authService: AuthService,
    ) {
        super(service);
        /**
         * Устанавливаем дефолтные значения
         */
        this.data$.next(this.defaultValue);

        this.authService.user$.subscribe((user) => {
            if (user) {
                this.updateData();
            } else {
                this.clearData();
            }
        });
    }
    public defaultValue = [];

    public notFired$ = new BehaviorSubject<SpecialistViewInterface[]>([]);

    /**
     * Проверяем, что переданная дата метода еще актуальна по сравнению с текущей.
     * Дата метода является актуальной, если она еще не наступила.
     * Сравниваем даты как строки.
     * @param {string} dateString дата для проверки в формате mm.yyyy, например 01.2016
     */
    static isMethodDateActual(dateString: string): boolean {
        if (!dateString) {
            return false;
        }
        const date = new Date();
        const currentDate = date.getFullYear() + '.' + (date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1);
        const dateToCompare = dateString.split('.').reverse().join('.');
        return dateToCompare >= currentDate;
    }

    /**
     * Обновить данные специалиста, запросив по API используя id
     * @param id
     */
    public updateItem(id: number): Observable<SpecialistViewInterface> {
        return this._service.get({
            id,
        }).pipe(
            tap((card) => {
                if (card && card.id) {
                    this.replaceItemInData(card);
                    return;
                }
            })
        );
    }

    /**
     * Заменить данные специалиста на новые или добавить, если это был новый созданный
     * @param spec
     */
    private replaceItemInData(spec: SpecialistViewInterface) {
        const currentData: SpecialistViewInterface[] = this.data$.getValue();

        let wasReplaced = false;

        const newData = currentData.map(item => {
            if (item.id === spec.id) {
                wasReplaced = true;
                return spec;
            } else {
                return item;
            }
        });

        if (!wasReplaced) {
            newData.push(spec);
        }

        this.data$.next(this.processedData(newData));
    }

    public processedData(data: SpecialistViewInterface[]): SpecialistViewInterface[] {
        /**
         * Пропускаем данные через фильтр, чтобы выделить в отдельный поток не уволенных специалистов
         */
        this.notFired$.next(data.filter(item => item.status !== 3));

        return data;
    }

    public getById(id: number) {
        if (!id) {
            return null;
        }
        const list = this.data$.getValue();
        return list.find(spec => +spec.id === id);
    }
}
